// frontend/src/components/auth/ResetConfirm.js
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './LoginRegister.css';
import { API_BASE } from '../../api/config';

export default function ResetConfirm() {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [status, setStatus] = useState(null);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  const token = new URLSearchParams(location.search).get('token');

  useEffect(() => {
    if (!token) {
      setError('Reset token is missing or invalid.');
    }
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus(null);
    setError(null);

    if (password !== confirm) {
      setError('Passwords do not match.');
      return;
    }

    try {
      const res = await fetch(`${API_BASE}/api/auth/reset-confirm/${token}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password }),
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.message || 'Reset failed.');
      }

      setStatus('✅ Password updated successfully. Redirecting to login...');
      setTimeout(() => navigate('/login'), 3000);
    } catch (err) {
      console.error('❌ Reset confirm error:', err);
      setError('Reset failed. Your link may have expired or been used.');
    }
  };

  return (
    <div className="auth-container">
      <form onSubmit={handleSubmit}>
        <h2>Set New Password</h2>
        <input
          type="password"
          placeholder="New password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Confirm new password"
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
          required
        />
        <button type="submit">Reset Password</button>
        {status && <p className="status-message">{status}</p>}
        {error && <p className="error-message">{error}</p>}
      </form>
      <div className="auth-links">
        <p>Need to log in? <a href="/login">Go to login</a></p>
        <p>Or <a href="/register">create a new account</a></p>
      </div>
    </div>
  );
}
